import QRCode from 'qrcode'
let size = '7cm 5cm'
let css = `
  .container {
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    padding: 10px;
  }
  .qrcode{
    width: 3cm;
    float: right;
    margin: -10px -10px 0 0;
  }
  .qrcode img{
    width: 100%;
    height: 100%;
    padding: 0;
    display: block;
    object-fit: contain;
  }`

const html = (items) => {
  return new Promise((finalResolve) => {
    let promises = []
    items.forEach((item) => {
      promises.push(
        new Promise((resolve) => {
          QRCode.toDataURL(item.QRCode, {
            width: item.QRSize,
            errorCorrectionLevel: 'L'
          }).then((url) => {
            let html = [
              `<div class="qrcode">
                <img src="${url}">
              </div>
              <div class="id"><b>${item.identify || '-'}</b><span> ${item.numberLineItem > 1 ? `(${item.numberLineItem}items)` : ''}</span></div>
              <div class="name"><b>${item.buyerName || '-'}</b></div>`
            ]
            if (item?.seller) {
              html.push(`<div class="seller">Seller: ${item?.seller}</div>`)
            }
            if (item?.manufacturer) {
              html.push(`<div class="manufacturer">Manufacturer: ${item?.manufacturer}</div>`)
            }
            if (item?.lineItemSku) {
              html.push(`<div class="sku">Sku: ${item.lineItemSku}</div>`)
            }
            if (item?.buyerNote) {
              html.push(`<div class="note">Note: ${item.buyerNote}</div>`)
            }
            if (item.sellerNote) {
              html.push(`<div class="seller-note">Seller note: ${item.sellerNote}</div>`)
            }
            html.push(`<div class="attributes">`)
            Object.entries(item.lineItemAttributes || []).forEach(([key, values]) => {
              if (String(values).length > 0) {
                html.push(`<div><label>${key}: </label><div class="d-inline-block">${values || ''}</div></div>`)
              }
            })
            html.push(`</div>`)
            html.push(`<div class="note">`)
            Object.entries(item.lineItemNote || []).forEach(([, values]) => {
              ;(values || '').split('\n').forEach((value) => {
                html.push(`<div>${value || ''}</div>`)
              })
            })
            html.push(`</div>`)
            resolve(`<div class="container">${html.join('')}</div>`)
          })
        })
      )
    })

    Promise.all(promises).then((values) => {
      finalResolve(values.join('<div class="page-break"></div>'))
    })
  })
}

export default { html, css, size }
